import { hooplandiaLocal } from './hooplandiaTheme/hooplandiaLocal';
import { hooplandiaStructure } from './hooplandiaTheme/hooplandiaStructure';
import { brochureLocal } from './brochureLanding/brochureLocal';
import { brochureStructure } from './brochureLanding/brochureStructure';

function themeController() {
  hooplandiaLocal();
  hooplandiaStructure();
  brochureLocal();
  brochureStructure();
}

export { themeController };
